<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">DOSTAVNICA HLAD</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
    </div>

    <div class="customTable nadzornaPloca dnevniPlan">
      <dx-data-grid
        #tablicaDnevniPlan
        id="gridContainer"
        [dataSource]="tablica"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        noDataText="{{ poruka }}"
        keyExpr="idlot"
        [showBorders]="false"
        (onRowUpdated)="urediPoziciju($event)"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Dostavnica Hlad</h2>
            <!-- <p class="mt-0">Lorem ipsum</p> -->
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-editing
          mode="popup"
          selectTextOnEditStart="true"
          [allowUpdating]="true"
        >
          <dxo-popup
            [showTitle]="true"
            [width]="300"
            [height]="'auto'"
            title="Uredi"
          ></dxo-popup>
          <dxo-form labelLocation="top">
            <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
              <dxi-item dataField="komora"></dxi-item>
              <dxi-item dataField="redak"></dxi-item>
              <dxi-item dataField="strana"></dxi-item>
            </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="lot"
          caption="LOT"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="datum"
          caption="Datum"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="kolicina"
          caption="Količina"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="kutija"
          caption="Broj kutija"
          [width]="80"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="komora"
          caption="Komora"
          [width]="90"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="redak"
          caption="Redak"
          [width]="80"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="strana"
          caption="Strana"
          [width]="100"
          alignment="center"
        >
          <dxo-lookup
            [dataSource]="strane"
            displayExpr="naziv"
            valueExpr="naziv"
          >
          </dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="dokumentBroj"
          caption="Broj dokumenta"
          [width]="120"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="vrstaDokumenta"
          caption="Vrsta dokumenta"
          [width]="120"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="regOznaka"
          caption="Registracija"
          [width]="120"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="rbKamiona"
          caption="RB kamiona"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
